export default {
  data: function () {
    return {}
  },
  methods: {
    trackSignupInitial: function (source) {
      let event = 'trackSignupInitial'
      const partner = this.$partner.charAt(0).toUpperCase() + this.$partner.slice(1)
      if (this.$isEngCom) {
        event = event + partner
      }
      window.dataLayer.push({
        event: event,
        Category: 'Registration',
        Action: 'Inital',
        Label: source,
        Partner: partner
      })
    },
    trackSignupVerified: function (source) {
      let event = 'trackSignupVerified'
      const partner = this.$partner.charAt(0).toUpperCase() + this.$partner.slice(1)
      if (this.$isEngCom) {
        event = event + partner
      }
      window.dataLayer.push({
        event: event,
        Category: 'Registration',
        Action: 'Verified',
        Label: source,
        Partner: partner
      })
    },
    trackSigninSuccessful: function (source) {
      let event = 'trackSigninSuccessful'
      const partner = this.$partner.charAt(0).toUpperCase() + this.$partner.slice(1)
      if (this.$isEngCom) {
        event = event + partner
      }
      window.dataLayer.push({
        event: event,
        Category: 'Signin',
        Action: 'Account Exists - User signed in',
        Label: source,
        Partner: partner
      })
    },
    trackResourceDownloadGA: function (resourceID) {
      window.dataLayer.push({
        event: 'trackResourceDownload',
        Category: 'Resource',
        Action: 'Download',
        Label: resourceID
      })
    },
    trackStoryAnalytics: function (project) {
      if (window.dataLayer && (project.article || project.resource)) {
        // delay tracking to ensure page title has been set
        setTimeout(() => {
          window.dataLayer.push({
            event: 'trackStory',
            ProjectID: project.id,
            ArticleID: project.article ? project.article.id : 0,
            ArticleSection: project.article ? project.article.section : '',
            ArticleType: project.article ? project.article.type : '',
            ResourceID: project.resource ? project.resource.id : 0,
            ResourceType: project.resource ? project.resource.type.name : '',
            ArticleAuthor: project.user.fullName || project.user.userName,
            ArticleSource: this.$isEngComApp ? 'APP' : 'STY',
            PrimaryCategory: project.primaryCategoryID
          })
        }, 1000)
      }
    }
  }
}
